const images = {
    backArrow: require('./images/back-arrow.svg').default,
    nextTekLogo: require('./images/nextek-logo.svg').default,
    nextTekLogo2: require('./images/nextek-sytem-logo.svg').default,
    headerLogo: require('./images/header-logo.svg').default,
    // LinenTech's own brand assets, taken from linentech-v3. nextTekLogo above
    // is the corporate Nextek mark and its export is damaged — see README notes.
    linenTechLogo: require('./images/linentech-logo.svg').default,
    linenTechMark: require('./images/linentech-mark.svg').default,
    linenIqLogo: require('./images/lineniq-logo.svg').default,
    linenConnectLogo: require('./images/linen-connect.svg').default,
    equipmateLogo: require('./images/equipmate-logo.svg').default,
    linenDeskLogo: require('./images/linendesk-logo.svg').default,
    linenCrewLogo: require('./images/linencrew-logo.svg').default,
    // EquipMate and LinenIQ ship here as compact marks only, which cannot carry
    // the product name in an auth-card header. These are their full lockups
    // (mark + wordmark), taken from linentech-v3's public/lt_icons/.
    equipmateLockup: require('./images/equipmate-lockup.svg').default,
    linenIqLockup: require('./images/lineniq-lockup.svg').default,
    sideBanner: require('./images/side-banner-bg.png'),
    footerBGTop: require('./images/login-footer-bg2.png'),
    footerBGBottom: require('./images/login-footer-bg.png'),
    info: require('./images/info.png'),
    twoFa: require('./images/two-fa.png'),
};

export default images;